/**
 * The fine print under the sign-in card, from design prompt `10-sign-in.md`
 * item 8. Its links use the settings help card's terms and privacy constants,
 * so each URL has one definition. The wrapper keeps room for a second short
 * line below the sentence, such as a reCAPTCHA attribution.
 */
import { cn, FOCUS_RING, HIT_SLOP } from "@sportsmet/ui";
import type { ReactNode } from "react";

import {
  EXTERNAL_LINK_HINT,
  PRIVACY_URL,
  TERMS_URL,
} from "../account/helpAndAboutCopy";

const FINE_PRINT_LINK_CLASS = cn(
  "relative whitespace-nowrap text-primary underline underline-offset-2",
  FOCUS_RING,
  HIT_SLOP,
);

export const SignInFinePrint = (): ReactNode => (
  <div data-testid="sign-in-fine-print" className="flex flex-col gap-1">
    <p
      data-testid="sign-in-fine-print-line"
      className="text-caption text-ink-secondary"
    >
      By continuing you agree to our{" "}
      <a
        href={TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`terms ${EXTERNAL_LINK_HINT}`}
        data-testid="sign-in-terms-link"
        className={FINE_PRINT_LINK_CLASS}
      >
        terms
      </a>{" "}
      and{" "}
      <a
        href={PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`privacy policy ${EXTERNAL_LINK_HINT}`}
        data-testid="sign-in-privacy-link"
        className={FINE_PRINT_LINK_CLASS}
      >
        privacy policy
      </a>
      .
    </p>
  </div>
);
